var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"icon":'notes',"heading":_vm.label}},[_c('div',{staticClass:"highlight-title"},[_vm._v("\n    Cardiovascular System 1 of 11\n  ")]),_vm._v(" "),_c('div',{staticClass:"highlight"},[_c('a',{attrs:{"href":"#"}},[_vm._v("40-pack-year history of smoking")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }